export const itemStatus = [
	{
		value: '现货',
		label: '现货',
	},
	{
		value: '预定',
		label: '预定',
	},
];

export const itemType = [
	{
		value: '喵星人',
		label: '喵星人',
	},
	{
		value: '汪星人',
		label: '汪星人',
	},
];

const dog = [
	'干粮',
	'湿粮',
	'零食',
	'餐具',
	'尿布',
	'小窝',
	'玩具',
	'保健',
	'衣物',
	'外出',
];

const cat = [
	'猫砂',
	'猫粮',
	'罐头',
	'零食',
	'餐具',
	'药品',
	'猫窝',
	'爬架',
	'玩具',
	'衣物',
];

export const dogKinds = dog.map(kind => ({ value: kind, label: kind }));
export const catKinds = cat.map(kind => ({ value: kind, label: kind }));
